module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-new-connection-trigger-73c25cbd.svg";